import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Footer from './Components/Footer';
import Navbar from './Components/Navbar';
import Homepage from './pages/Homepage';
import Contact from './pages/Contact';
import Errorpages from './pages/Errorpage';

import Development from './pages/Course/development';
import Markteing from './pages/Course/Markteing';
import Seocourse from './pages/Course/Seocourse';


function App() {


  
  return (
    <>
      <BrowserRouter>

        <Navbar />
        <Routes>
          <Route path='/' element={<Homepage />} />
          <Route path='/Contact' element={<Contact/>} />
          <Route path='/Development' element={<Development/>} />
          <Route path='/Markteing' element={<Markteing/>} />
          <Route path='/Seo-course' element={<Seocourse/>} />
          <Route path='*' element={<Errorpages/>} />
       
       
        </Routes>
        <Footer />

      </BrowserRouter>
    </>
  );
}

export default App;
